
import React from 'react';
import { useBooking } from '../../context/BookingContext';
import { Check } from 'lucide-react';

const BookingProgress: React.FC = () => {
  const { state, goToStep } = useBooking();
  const { step } = state;

  const steps = [
    { id: 1, label: 'Doctor' },
    { id: 2, label: 'Date & Time' },
    { id: 3, label: 'Details' },
    { id: 4, label: 'Review' },
  ];

  const getStepClass = (stepId: number) => {
    if (stepId < step) return 'booking-progress-step completed';
    if (stepId === step) return 'booking-progress-step active';
    return 'booking-progress-step';
  };

  const getConnectorClass = (stepId: number) => {
    return stepId < step ? 'booking-progress-connector active' : 'booking-progress-connector';
  };

  const handleStepClick = (stepId: number) => {
    if (stepId < step) {
      goToStep(stepId);
    }
  };

  return (
    <div className="w-full mb-8">
      <div className="flex items-center">
        {steps.map((s, index) => (
          <React.Fragment key={s.id}>
            <div 
              className={getStepClass(s.id)}
              onClick={() => handleStepClick(s.id)}
            >
              {s.id < step ? <Check className="h-4 w-4" /> : s.id}
            </div>
            {index < steps.length - 1 && (
              <div className={getConnectorClass(s.id + 1)} />
            )}
          </React.Fragment>
        ))}
      </div>
      
      <div className="flex justify-between mt-2">
        {steps.map((s) => (
          <div 
            key={`label-${s.id}`} 
            className={`text-xs ${s.id === step ? 'text-primary font-medium' : 'text-muted-foreground'}`}
            style={{ width: '25%', textAlign: 'center' }}
          >
            {s.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookingProgress;
